'use client';

import { useWindowSizeIsLessThan } from './useWindowSize';

const useIsMobileScreenSize = () => useWindowSizeIsLessThan('sm');

export default useIsMobileScreenSize;
